module.exports = __webpack_public_path__ + "static/media/airtel.0f92f4f1.png";